var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-flex uk-flex-row"},[_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value ? 'checked' : null},on:{"click":_vm.newValue}}),_c('span',{staticClass:"slider round"})]),_c('div',{staticClass:"uk-flex service-name"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }